import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DocumentoTipo } from 'src/app/shared/models/documento-tipo';
import { DocumentoTipoService } from 'src/app/core/services/documento-tipo.service';

@Component({
    selector: 'app-documento-tipo-editar',
    templateUrl: './documento-tipo-editar.component.html',
    styleUrls: ['./documento-tipo-editar.component.css'],
})
export class DocumentoTipoEditarComponent implements OnInit {
    @ViewChild('documentoTipoForm') formValues;

    form: FormGroup;
    breadCrumb;
    documentos_tipo: DocumentoTipo;
    carregando: boolean;
    submited: boolean;
    codigo_documento_tipo: any;

    constructor(
        private appComponent: AppComponent,
        private formBuilder: FormBuilder,
        private routerParam: ActivatedRoute,
        private router: Router,
        private documentoTipoService: DocumentoTipoService,
        private notifierService: NotifierService,
    ) {
        this.codigo_documento_tipo = this.routerParam.snapshot.params.id;
    }

    ngOnInit() {
        this.carregando = true;
        this.breadCrumb = [
            { nome: 'Configuração', caminho: '/configuracao' },
            { nome: 'documentos_tipo', caminho: '/documentos-tipo-listar' },
        ];
        if (this.codigo_documento_tipo) {
            this.appComponent.setTitulo('Alteração de documento tipo');
        } else {
            this.appComponent.setTitulo('Cadastro de documento tipo');
        }
        this.appComponent.setBreadcrumb(this.breadCrumb);

        this.form = this.formBuilder.group({
            codigo_documento_tipo: [null],
            nome: [null, Validators.required],
        });

        this.obter();
    }

    obter(): void {
        this.documentoTipoService
            .find(this.codigo_documento_tipo)
            .subscribe((data: DocumentoTipo) => {
                this.form.patchValue({
                    codigo_documento_tipo: data.codigo_documento_tipo,
                    nome: data.nome,
                });
            });
    }

    onSubmit(): void {
        this.submited = true;
        this.carregando = true;
        const documento_tipo = this.form.value as DocumentoTipo;
        if (this.form.valid) {
            this.documentoTipoService
                .save(documento_tipo, this.codigo_documento_tipo)
                .subscribe(
                    (data) => {
                        this.notifierService.notify(
                            'success',
                            'Documento tipo cadastrada com sucesso.',
                        );
                        this.carregando = false;
                        this.router.navigate(['documento-tipo-listar']);
                    },
                    (error) => {
                        this.notifierService.notify(
                            'error',
                            'Não foi cadastrar uma nova Documento Tipo. ' +
                                error,
                        );
                        this.carregando = false;
                    },
                );
        } else {
            console.log(this.form);
            this.notifierService.notify(
                'error',
                'Existem erros no preenchimento do formulário.',
            );
            this.carregando = false;
        }
    }
}
